import { ClaimRewardSchema } from '@betty/toolkit/services';
import z from 'zod';

export const StatusSchema = z.enum([
  'Member',
  'Amethyst',
  'Topaz',
  'Aquamarine',
  'Opal',
  'Emerald',
  'Ruby',
  'Sapphire',
  'Diamond',
  'Vip',
]);

export const PlayerStatusStateSchema = z.enum([
  'ToBePromoted',
  'ToBeDemoted',
  'ToBeKept',
  'Expired',
  'Active',
  'Completed',
]);

export const StatusRewardSchema = z.object({
  rewardId: z.number(),
  rewardType: z.string(),
  expiryDate: z.string().optional(),
  sourceType: StatusSchema,
});

const StatusesSchema = z.object({
  name: z.string(),
  maxDaysToComplete: z.number().optional(),
  keepStatusBoxCount: z.number().optional(),
  promotionBoxCount: z.number().optional(),
});

export const StatusConfigResponseSchema = z.object({
  boxAutoRewardDays: z.number().optional(),
  statuses: z.array(StatusesSchema).optional(),
});

export const StatusResponseSchema = z.object({
  playerStatus: StatusSchema,
  playerStatusState: PlayerStatusStateSchema,
  startDate: z.string().datetime().optional(),
  expiryDate: z.string().datetime().optional(),
  accumulatedLoyaltyPoints: z.number(),
  totalLoyaltyPoints: z.number(),
  pendingRewards: z.array(StatusRewardSchema).default([]),
  claimedBoxesCount: z.number().optional(),
  keepStatusNumberOfBoxes: z.number().optional(),
  promotionNumberOfBoxes: z.number().optional(),
  totalBoxesCount: z.number().optional(),
  nextPlayerStatus: StatusSchema.optional(),
  nextStatusTotalBoxesCount: z.number().optional(),
});

export const ClaimAllStatusRewardsResponseSchema = z.object({
  rewards: z.array(ClaimRewardSchema),
});
